// import axios from '../../axios';

// initial state
const state = {
};

// getters
const getters = {
    allmedia: (state) => {
        state;
        return {
            // 自動ソート防止
            api: [
                [1, 'Facebook広告'],
                [2, 'Facebookダイナミック広告'],
                [3, 'Yahoo検索広告'],
                [4, 'Yahooディスプレイ広告'],
                [5, 'Google広告'],
                [6, 'Googleショッピング広告'],
                [12, 'GoogleP-max広告'],
                [24, 'Googleデマジェネ広告'],
                [7, 'Line広告'],
                [8, 'Criteo広告'],
                [21, 'Microsoft広告'],
            ],
            manual: [
                [9, 'TimeTree広告'],
                [10, 'TikTok広告'],
                [11, 'Criteo広告'],
                [13, 'Pinterest広告'],
                [14, 'docomo広告'],
                [15, '予備①'],
                [16, 'Twitter']
            ],
            mallApi: [
                [4,'楽天（amepla）'],
                [10,'楽天（ネルチャー）'],
                [5,'楽天（整体ラボ）'],
            ],
            mallAdType: [
                [2,'楽天市場広告'],
                [3,'楽天RPP広告'],
                [4,'楽天クーポンアドバンス広告'],
                [5,'楽天CPA広告'],
                [6,'楽天TDA広告'],
            ]
        };
    }
};

// actions
const actions = {
    // fetch: async function(context) {
    //     // TODO: request
    //     // const res = await axios.get('');
    //     // context.commit('set', res.data);
    // },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};